<template>
  <div class="sf-row">
    <div class="tw-px-3 tw-max-w-full tw-max-h-[378px] tw-overflow-y-auto">
      <div
        v-if="entries.length === 0"
        class="sf-alignc sf-c-text sf-bg-snow-dark sf-font-l sf-pad-4 sf-dim-el"
      >
        {{ I18n.t('permanent_document.modal_select.empty_folder') }}
      </div>
      <table
        v-else
        class="sf-table sf-table-border sf-table-middle tw-table-fixed"
      >
        <thead>
          <tr>
            <th>
              {{
                I18n.t('components.document.existing_docs_modal.export_name')
              }}
            </th>
            <th>
              {{ I18n.t('components.document.existing_docs_modal.author') }}
            </th>
            <th class="tw-whitespace-nowrap">
              {{
                I18n.t('components.document.existing_docs_modal.exported_at')
              }}
            </th>
            <th class="tw-w-12 tw-min-w-12" />
          </tr>
        </thead>
        <tbody>
          <ExportsTableRow
            v-for="entry in entries"
            :key="entry.id"
            :selected="selectedEntriesIds.includes(entry.id)"
            :entry="entry"
            @toggle-selection="emit('toggleSelection', entry)"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang="ts">
import ExportsTableRow from '@app/application/reconciliation/sections/exports-table-row.vue'
import { ExportType } from '@app/application/export/types'
import useI18n from '@app/shared/vue/composables/use-I18n'

interface Props {
  entries: ExportType[]
  selectedEntriesIds: number[]
}

defineProps<Props>()

const emit = defineEmits<{ toggleSelection: [ExportType] }>()

const I18n = useI18n()
</script>
